<ng-template #modalTemplate>
  <div class="modal-header">
    <h2 class="modal-title text-center w-100">{{ title }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
  <div class="modal-body">
    <p>{{ message }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" [class]="'btn btn-min-width ' + cancelButtonClass" (click)="onCancel()">
      {{ cancelButtonText }}
    </button>
    <button type="button" [class]="'btn btn-min-width ' + confirmButtonClass" (click)="onConfirm()">
      {{ confirmButtonText }}
    </button>
  </div>
</ng-template>
